"use client"

import React from 'react'
import { PLANNING_TAB_LINKS, PlanningTabLink, SEARCH_PARAMS_TAB_KEY } from '../constants/planning-tab-links'
import Link from 'next/link'
import { cn, buildRegionUrl } from '../../../shared/lib/utils'
import { useRegion } from '../../../shared/hooks/use-region'
import { useSession } from '@/features/auth/context/session.context'
import { UserRole } from '@/shared/constants/user-roles'

function PlanningTabs({ tab }: { tab?: PlanningTabLink }) {
    const { regionSlug } = useRegion()
    const { session } = useSession()
    const canViewPriority = session?.role === UserRole.ADMIN || 
                          session?.role === UserRole.BASE_LEADER || 
                          session?.role === UserRole.TEAM_LEADER || 
                          session?.role === UserRole.VOLUNTEER
    const canViewAiChat = session?.role === UserRole.ADMIN || session?.role === UserRole.BASE_LEADER
    
    // Filter out tabs for users who don't have access
    const visibleTabs = PLANNING_TAB_LINKS.filter(link => {
        if (link.value === 'priority' && !canViewPriority) return false
        if (link.value === 'ai-chat' && !canViewAiChat) return false
        return true
    })
    
    // Determine default tab for active state - always default to filter-search
    const defaultTab = 'filter-search'
    
    return (
        <div className="flex items-center justify-center gap-5">
            {visibleTabs.map((link) => {
                // Build region-aware URL
                const href = regionSlug
                    ? buildRegionUrl(regionSlug, '/homeowners', { [SEARCH_PARAMS_TAB_KEY]: link.value })
                    : `/homeowners?${SEARCH_PARAMS_TAB_KEY}=${link.value}`
                
                return (
                    <Link
                        key={link.value}
                        href={href}
                        data-tab-value={link.value}
                        className={cn(
                            'w-[100px] text-center pb-0.5 border-b-[3px] border-transparent',
                            {
                                "border-primary text-primary font-medium": 
                                    link.value === tab || (!tab && link.value === defaultTab),
                            }
                        )}
                    >
                        {link.label}
                    </Link>
                )
            })}
        </div>
    )
}

export default PlanningTabs
